module.exports = __webpack_public_path__ + "static/media/finance.73dfbe63.webp";